import CtaBand from "@/components/feature/CtaBand";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import ServicesOverview from "./components/ServicesOverview";
import WhyChoose from "./components/WhyChoose";

export default function Home() {
  return (
    <>
      <Hero />
      <IntroSection />
      <ServicesOverview />
      <WhyChoose />
      <div className="pt-16 md:pt-24">
        <CtaBand />
      </div>
    </>
  );
}